import { useQuery } from "@tanstack/react-query"
import {
  fetchAutomations,
  fetchSegments,
  fetchSequences,
  fetchTags,
  searchBroadcasts,
  searchForms,
  searchSubscribers,
  searchTags
} from "sdk/command-palette"

export const commandPaletteKeys = {
  all: ["command-palette"],
  subscriberSearch: query => [...commandPaletteKeys.all, "subscribers", query],
  broadcastSearch: query => [...commandPaletteKeys.all, "broadcasts", query],
  formSearch: query => [...commandPaletteKeys.all, "forms", query],
  tags: () => [...commandPaletteKeys.all, "tags"],
  tagSearch: query => [...commandPaletteKeys.all, "tags", query],
  segments: () => [...commandPaletteKeys.all, "segments"],
  sequences: () => [...commandPaletteKeys.all, "sequences"],
  automations: () => [...commandPaletteKeys.all, "automations"]
}

export function useSearchSubscribers({ params, ...queryConfig }) {
  return useQuery({
    queryKey: commandPaletteKeys.subscriberSearch(params.query),
    queryFn: () => searchSubscribers(params),
    ...queryConfig
  })
}

export function useSearchBroadcasts({ params, ...queryConfig } = {}) {
  return useQuery({
    queryKey: commandPaletteKeys.broadcastSearch(params.query),
    queryFn: () => searchBroadcasts(params),
    ...queryConfig
  })
}

export function useSearchForms({ params, ...queryConfig } = {}) {
  return useQuery({
    queryKey: commandPaletteKeys.formSearch(params.query),
    queryFn: () => searchForms(params),
    ...queryConfig
  })
}

export function useTags(queryConfig = {}) {
  return useQuery({
    queryKey: commandPaletteKeys.tags(),
    queryFn: fetchTags,
    // The tag list changes rarely; cache it so reopening the subpage within a
    // session doesn't refetch the whole list.
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...queryConfig
  })
}

export function useSearchTags({ params, ...queryConfig }) {
  return useQuery({
    queryKey: commandPaletteKeys.tagSearch(params.query),
    queryFn: () => searchTags(params),
    staleTime: 5 * 60 * 1000,
    ...queryConfig
  })
}

export function useSegments(queryConfig = {}) {
  return useQuery({
    queryKey: commandPaletteKeys.segments(),
    queryFn: fetchSegments,
    // The segment list changes rarely; cache it so reopening the subpage within
    // a session doesn't refetch the whole list.
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...queryConfig
  })
}

export function useSequences(queryConfig = {}) {
  return useQuery({
    queryKey: commandPaletteKeys.sequences(),
    queryFn: fetchSequences,
    // The sequence list changes rarely; cache it so reopening the subpage within
    // a session doesn't refetch the whole list.
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...queryConfig
  })
}

export function useAutomations(queryConfig = {}) {
  return useQuery({
    queryKey: commandPaletteKeys.automations(),
    queryFn: fetchAutomations,
    // The automation list changes rarely; cache it so reopening the subpage
    // within a session doesn't refetch the whole list.
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...queryConfig
  })
}
